<template>
<div :key="hotel.id"  class="col-lg-3 col-6" :class="{'offset-lg-3' : hasOffset}">
  <a :href="hotel.link">
    <article class="property-listing">
      <div class="images">
        <div class="tile-background tile-placeholder image"></div>
          <img
            :class="{loaded: imageLoaded}"
            class="tile-background tile-image image"
            :style="`background-image: url('${imageUrl}')`"
            :alt="imageAlt">
      </div>

      <h3 class="city">
        <span v-html="getCityFromHotelAddress()"></span>
      </h3>

      <h4 class="bold-heading">
        <span v-html="hotel.title.rendered"></span>
      </h4>
    </article>
  </a>
</div>
</template>

<script>
export default {
  name: 'HotelTile',
  props: {
    hotel: {
      type: Object,
      required: true
    },
    hasOffset: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      image: null,
      imageLoaded: false,
      imageUrl: '',
      imageAlt: '',
      domObserver: null
    }
  },
  mounted () {
    document.addEventListener('scroll', this.loadImageIfVisible)
    this.loadImageIfVisible()

    // This is needed because Vue is a little too aggressive in caching components.
    // Select the node that will be observed for mutations. Each tile only watches it'
    let targetNode = document.getElementById('property-listings-container')
    this.domObserver = new MutationObserver((mutationsList, observer) => {
      this.loadImageIfVisible()
    })
    this.domObserver.observe(targetNode, { childList: true, subtree: true })
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.loadImageIfVisible)
    this.domObserver.disconnect()
  },
  methods: {
    loadImageIfVisible () {
      if (this.image) return  // Return if it's loading.

      let windowHeight = window.innerHeight
      let rect = this.$el.getBoundingClientRect()

      // 250px margin below the fold in the window.
      if (rect.top < (windowHeight + 250)) {
        this.loadImage()
      }
    },
    loadImage () {
      let url = this.hotel.hotel_images
        ? this.hotel.hotel_images[0].hotel_image.sizes.large
        : `/wp-content/themes/innvest/img/map/fairmont.jpg`
      let alt = this.hotel.hotel_images
        ? this.hotel.hotel_images[0].hotel_image.alt
        : this.hotel.title.rendered + ' Hotel Exterior'

      this.image = new Image()
      this.imageAlt = alt

      this.image.onload = () => {
        this.imageLoaded = true
        this.imageUrl = url
      }

      this.image.src = url
    },
    getCityFromHotelAddress () {
      var address = this.hotel.address.address.split(', ')
      return address[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/hotel-tile.vue